const valueMappings = {
  // add your other mappings here if there are any
  player_worn: 'Player Worn',
  game_worn: 'Game Worn',
  not_specific: 'No specific game',
  None: 'None',
  mint: 'Mint/Near Mint',
  excellent: 'Excellent',
  very_good: 'Very Good',
  poor: 'Poor',
  not_sepcified: 'Not specified',
};

export const center_fields = [
  createField('Card Category', 'select', {
    attachOnChange: true,
    required: true,
    options: ['Pick Category', 'Baseball', 'Basketball', 'Football', 'Golf', 'Hockey', 'MMA', 'Racing', 'Soccer', 'Tennis', 'Pokemon', 'Magic: The Gathering', 'Yu-Gi-Oh!', 'TCG', 'Non-sports'],
  }),
];

export const center_detected_fields = [
  createField('Card Category', 'select', {
    attachOnChange: true,
    required: true,
    options: ['Pick Category', 'Baseball', 'Basketball', 'Football', 'Golf', 'Hockey', 'MMA', 'Racing', 'Soccer', 'Tennis', 'Pokemon', 'Magic: The Gathering', 'Yu-Gi-Oh!', 'TCG', 'Non-sports'],
  }),
];

export const left_detected_fields = [
  createField('Card Identifier', 'text', {
    attachOnChange: true,
    required: true,
    pattern:
      '^(?:(?:No\\.|Card No\\.)\\s*)?[A-Z0-9]+(?:-[A-Z0-9]+)*(?:/[A-Z0-9]+)?$',
    patternMsg:
      'Identifier may start with "No." or "Card No." followed by alphanumeric characters, optionally separated by hyphens. e.g., "No. SMP-DJO" or "ABC-123"',
    tooltipText:
      'Enter the card identifier when visible. It often starts with No. or Card No. E.g., No. SMP-DJO.',
  }),
  createField('Card Subject(s)', 'text', {
    attachOnChange: true,
    required: true,
  }),
  createField('Year', 'text', {
    attachOnChange: true,
    required: true,
    pattern: '\\d{4}(-\\d{2})?',
    patternMsg: 'YYYY or YYYY-YY',
  }),
  createField('Manufacturer', 'text', { attachOnChange: true, required: true }),
  // Bottom-left field
  createField('Team', 'text', {
    attachOnChange: true,
  }),
];

export const right_detected_fields = [
  createField('Box Set', 'text', { attachOnChange: true, required: true }),
  createField('Patch', 'select', {
    attachOnChange: true,
    options: ['None', 'No specific game', 'Player Worn', 'Game Worn'],
  }),
  createField('Auto', 'radio', {
    attachOnChange: true,
    options: ['Yes', 'No'],
  }),
  createField('Number', 'text', {
    attachOnChange: true,
    pattern: '\\d+/\\d+',
    patternMsg: 'x/y, Example: 01/99',
    tooltipText: 'We only detect number if it is visible in the uploaded image.',
  }),
  // Bottom-right field
  createField('Position', 'text', {
    attachOnChange: true,
  }),
];

export const manual_fields = [
  createField('Release Set', 'text', {
    tooltipText: 'Confirm or enter the release set.',
  }),
  createField('Parallel', 'text', {
    tooltipText: 'Confirm or enter the color or parallel.',
  }),
  createField('Grade', 'text', {
    tooltipText: 'We do not automatically detect the grade at this time.',
  }),
  createField('Grading Company', 'text', {
    tooltipText:
      'We do not automatically detect the grading company at this time.',
  }),
  createField('Condition', 'select', {
    options: [
      'Not specified',
      'Mint/Near Mint',
      'Excellent',
      'Very Good',
      'Poor',
    ],
  }),
  createField('Collections', 'checkbox', { multiple: true, required: true }),
];

export function createManualFieldsWithOptions(
  releaseSetOptions = [],
  parallelOptions = []
) {
  const fields = manual_fields.map((field) => ({ ...field }));

  if (releaseSetOptions.length > 0) {
    fields[0] = createField('Release Set', 'select', {
      options: ['', ...releaseSetOptions],
      tooltipText: 'Select the most likely release set identified from the card.',
    });
  }

  if (parallelOptions.length > 0) {
    fields[1] = createField('Parallel', 'select', {
      options: ['', ...parallelOptions],
      tooltipText: 'Select the most likely color or parallel identified from the card.',
    });
  }

  return fields;
}

export const left_column_fields = [
  createField('Card Identifier', 'text', {
    attachOnChange: true,
    required: true,
    pattern:
      '^(?:(?:No\\.|Card No\\.)\\s*)?[A-Z0-9]+(?:-[A-Z0-9]+)*(?:/[A-Z0-9]+)?$',
    patternMsg:
      'Identifier may start with "No." or "Card No." followed by alphanumeric characters, optionally separated by hyphens. e.g., "No. SMP-DJO" or "ABC-123"',
    tooltipText:
      'Enter the card identifier when visible. It often starts with No. or Card No. E.g., No. SMP-DJO.',
  }),
  createField('Card Subject(s)', 'text', {
    attachOnChange: true,
    required: true,
  }),
  createField('Team', 'text', {
    attachOnChange: true,
  }),
  createField('Position', 'text', {
    attachOnChange: true,
  }),
  createField('Year', 'text', {
    attachOnChange: true,
    required: true,
    pattern: '\\d{4}(-\\d{2})?',
    patternMsg: 'YYYY or YYYY-YY',
  }),
  createField('Manufacturer', 'text', { attachOnChange: true, required: true }),
  createField('Box Set', 'text', { attachOnChange: true, required: true }),
  createField('Release Set', 'text', {}),
];

export const right_column_fields_nopulse = [
  createField('Number', 'text', {
    attachOnChange: true,
    pattern: '\\d+/\\d+',
    patternMsg: 'x/y, Example: 01/99',
  }),
  createField('Patch', 'select', {
    attachOnChange: true,
    options: ['None', 'No specific game', 'Player Worn', 'Game Worn'],
  }),
  createField('Auto', 'radio', {
    attachOnChange: true,
    options: ['Yes', 'No'],
  }),
  createField('Grading Company', 'text', {}),
  createField('Grade', 'text', {}),
  createField('Parallel', 'text', {}),
  createField('Condition', 'select', {
    options: [
      'Not specified',
      'Mint/Near Mint',
      'Excellent',
      'Very Good',
      'Poor',
    ],
  }),
  createField('Collections', 'checkbox', { multiple: true, required: true }),
];

export const left_listing_fields = [
  createField('Card Identifier', 'text', {
    required: true,
    pattern:
      '^(?:(?:No\\.|Card No\\.)\\s*)?[A-Z0-9]+(?:-[A-Z0-9]+)*(?:/[A-Z0-9]+)?$',
    patternMsg:
      'Identifier may start with "No." or "Card No." followed by alphanumeric characters, optionally separated by hyphens. e.g., "No. SMP-DJO" or "ABC-123"',
    tooltipText:
      'Enter the card identifier when visible. It often starts with No. or Card No. E.g., No. SMP-DJO.',
  }),
  createField('Card Subject(s)', 'text', { required: true }),
  createField('Team', 'text', {}),
  createField('Position', 'text', {}),
  createField('Year', 'text', {
    required: true,
    pattern: '\\d{4}(-\\d{2})?',
    patternMsg: 'YYYY or YYYY-YY',
  }),
  createField('Manufacturer', 'text', { required: true }),
  createField('Box Set', 'text', { required: true }),
  createField('Release Set', 'text', {}),
];

export const right_listing_fields = [
  createField('Number', 'text', {
    pattern: '\\d+/\\d+',
    patternMsg: 'x/y, Example: 01/99',
  }),
  createField('Patch', 'select', {
    options: ['None', 'No specific game', 'Player Worn', 'Game Worn'],
  }),
  createField('Auto', 'radio', { options: ['Yes', 'No'] }),
  createField('Grading Company', 'text', {}),
  createField('Grade', 'text', {}),
  createField('Parallel', 'text', {}),
  createField('Condition', 'select', {
    required: true,
    options: ['', 'Mint/Near Mint', 'Excellent', 'Very Good', 'Poor'],
  }),
  createField('Photos', 'select', {
    required: true,
    options: [
      '',
      'Front Only',
      'Front and Corners',
    ],
  }),
];

const priceRegex = '^\\$?(\\d{1,3}(,\\d{3})*|\\d*)(\\.\\d{2})?$';
export const getListingFields = (
  eventHandlers = {},
  { fulfillmentPolicies = [], paymentPolicies = [], returnPolicies = [] } = {}
) => {
  const fields = [
    createField('Title', 'text', { required: true, maxlength: 80 }),
    createField('Description', 'text', { required: true, rows: 5 }),
    createField('Listing Options', 'checkbox', {
      required: true,
      options: ['Auction', 'Buy It Now', 'Allow Offers'],
      eventHandlers: {
        change: eventHandlers.onListingTypeChange,
      },
    }),
    createField('Starting Bid (USD)', 'text', {
      groupName: 'Auction',
      required: true,
      pattern: priceRegex,
      patternMsg: '$X.XX',
      width: '100px',
    }),
    createField('Duration', 'select', {
      groupName: 'Auction',
      required: true,
      options: ['3 days', '5 days', '7 days', '10 days'],
    }),
    createField('BIN Price (USD)', 'text', {
      groupName: 'BuyItNow',
      required: true,
      pattern: priceRegex,
      patternMsg: '$X.XX',
      width: '100px',
    }),
    createField('Minimum Offer (USD)', 'text', {
      groupName: 'Offer',
      required: true,
      pattern: priceRegex,
      patternMsg: '$X.XX',
      width: '100px',
    }),
    createField('Auto-accept (USD)', 'text', {
      groupName: 'Offer',
      required: false,
      pattern: priceRegex,
      patternMsg: '$X.XX',
      width: '100px',
    }),
  ];

  if (fulfillmentPolicies.length > 0) {
    fields.push(
      createField('Fulfillment Policy', 'select', {
        required: true,
        options: fulfillmentPolicies.map((p) => p.name || p.policyName || p.id),
      })
    );
  } else {
    fields.push(
      createField('Shipping Service', 'select', {
        required: true,
        options: ['eBay Standard Envelope', 'USPS First Class', 'USPS Priority'],
      })
    );
    fields.push(
      createField('Shipping Fees', 'text', {
        required: true,
        tooltipText: 'Fees the Buyer will pay. Input 0 for Free Shipping.',
        pattern: priceRegex,
        patternMsg: '$X.XX',
        width: '100px',
      })
    );
    fields.push(
      createField('Handling Time', 'select', {
        required: true,
        options: [
          '1 business day',
          '2 business days',
          '3 business days',
          '4 business days',
          '5 business days',
        ],
      })
    );
  }

  if (paymentPolicies.length > 0) {
    fields.push(
      createField('Payment Policy', 'select', {
        required: true,
        options: paymentPolicies.map((p) => p.name || p.policyName || p.id),
      })
    );
  }

  fields.push(
    createField('Item Location', 'text', {
      required: true,
      tooltipText: 'We only support selling from the United States at this time.',
      readonly: true,
      defaultValue: 'United States',
      width: '200px',
    })
  );

  if (returnPolicies.length > 0) {
    fields.push(
      createField('Return Policy', 'select', {
        required: true,
        options: returnPolicies.map((p) => p.name || p.policyName || p.id),
      })
    );
  } else {
    fields.push(
      createField('Return Policy', 'select', {
        required: true,
        tooltipText: 'We only support a no return policy.',
        options: ['No returns accepted'],
      })
    );
  }

  return fields;
};

export const reddit_post_fields = [
  createField('Photos', 'select', {
    required: true,
    options: [
      '',
      'Front Only',
      'Front and Corners',
    ],
  }),
  createField('Subreddit', 'select', {
    required: true,
    options: [
      '',
      'sportscards',
      'baseballcards',
      'basketballcards',
      'footballcards',
      'FootballCardz',
      'hockeycards',
      'soccercard',
      'ufccards'
    ],
  }),
  createField('Title', 'text', { required: true, rows: 5 }),
  // createField('Post collection link in comments', 'checkbox', {
  //   required: false,
  // }),
];

export const responseToFormFieldMapping = {
  identifier: 'Card Identifier',
  manufacturer: 'Manufacturer',
  program: 'program',
  subjects: 'Card Subject(s)',
  players: 'Card Subject(s)',
  team_override: 'Team',
  position_override: 'Position',
  year: 'Year',
  autograph: 'Auto',
  auto: 'Auto',
  grade: 'Grade',
  grading_company: 'Grading Company',
  card_type: 'Card Category',
  condition: 'Condition',
  // Add more mappings as needed
};

export function selectValueTransformer(value) {
  // Optionally use inputName if the transformation depends on the input
  return valueMappings[value] || value;
}

function createField(
  name,
  type,
  {
    attachOnChange = false,
    required = false,
    pattern = '',
    patternMsg = '',
    options = [],
    shouldPulse = false,
    tooltipText = '',
    rows = 1,
    groupName = '',
    width = '',
    maxlength = 0,
    readonly = false,
    defaultValue = '',
    multiple = false,
    eventHandlers = {},
  } = {}
) {
  const field = { name, type };
  const validationMessage = {};

  if (attachOnChange) {
    field.attachOnChange = true;
  }

  if (required) {
    validationMessage.valueMissing = `${name} is required.`;
    field.required = true;
  }
  if (pattern) {
    field.pattern = pattern;
    validationMessage.patternMismatch = `${name} must be input like ${patternMsg}.`;
  }

  validationMessage.default = `Unknown error in field ${name}.`;

  if (groupName) {
    field.groupName = groupName;
  }

  if (options.length) {
    field.options = options;
  }

  if (multiple) {
    field.multiple = true;
  }

  if (shouldPulse) {
    field.shouldPulse = true;
  }

  if (tooltipText) {
    field.tooltipText = tooltipText;
  }

  if (Object.keys(validationMessage).length) {
    field.validationMessage = validationMessage;
  }

  if (type == 'text') {
    field.rows = rows;
  }

  if (width) {
    field.width = width;
  }

  if (maxlength) {
    field.maxlength = maxlength;
  }

  if (readonly) {
    field.readonly = true;
  }

  if (defaultValue) {
    field.defaultValue = defaultValue;
  }

  // Event handlers (for radio buttons and others)
  if (Object.keys(eventHandlers).length) {
    field.eventHandlers = eventHandlers;
  }

  return field;
}
